import {AbstractSerialBadgeType} from './abstract-serial-badge-type';

export class EnergyLevelMorningBadgeType extends AbstractSerialBadgeType {
  constructor() {
    super();
    this.name = 'energyLevelMorning';
    this.prettyName = 'Energiebewertung morgens';
    this.icon = 'battery-half';
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/badges/energy-level-morning-badge-type.ts